/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import Component from '@ember/component';
import { assert } from '@ember/debug';

@tagName('')
export default class CioConditionEditor extends Component {
  allowMessageWildcardSelection = false;
  allowInParentWildcardSelection = false;
  conditionTree = null;
  errorMessage = null;
  segment = null;

  @computed('conditionTree.type')
  get validTree() {
    let rootType = this.get('conditionTree.type');
    let valid = rootType === 'group';

    assert(`First condition must be a group, is "${rootType}"`, valid);

    return valid;
  }
}
